import type { HTMLProps, ReactNode } from 'react';
import tw, { type TwStyle } from 'twin.macro';

type LabelProps = {
  children: ReactNode;
  cssExtend?: TwStyle | (TwStyle | undefined)[];
  isError?: boolean;
  isRequired?: boolean;
} & HTMLProps<HTMLLabelElement>;

const Label = ({
  cssExtend,
  children,
  isError = false,
  isRequired = false,
  ...labelProps
}: LabelProps) => (
  <label
    css={[tw`block w-fit`, isError && tw`text-red-2`, cssExtend]}
    data-testid="Label"
    {...labelProps}
    data-cy="Label_label"
  >
    {children} {isRequired && '*'}
  </label>
);

export default Label;
